
<div class="w-full md:px-[3.5rem]">
       
    <div class="container mx-auto mt-16">

        <h1 class="font-dm-sans text-[var(--dark-teal)] text-2xl md:text-3xl mb-4">{{auctionsTotal}} results for
            “{{query}}”
        </h1>

        <app-custom-breadcrumb [isColorLight]="true" [separatorIsChevron]="true"></app-custom-breadcrumb>

        <div class="flex justify-between mt-10">

            <div class=" hidden flex mb-4 ">
                <p-select [options]="sortFilters" [(ngModel)]="selectedSortSignal" placeholder="Sort by"
                    class="text-xs w-full h-[35px] md:w-[300px]">
                </p-select>
            </div>


            <div class=" hidden md:block md:ml-auto">
                <p-selectbutton [options]="this.ItemListOptions" [(ngModel)]="viewMode" optionLabel="label"
                    optionValue="value" allowEmpty="false" class="custom-p-selectbutton h-[37px] border-none  md:ml-auto">
                    <ng-template #item let-item class="">
                        <p-button severity="info" [text]="item.value!=viewMode" class="custom-p-button">
                            <fa-icon class="text-[12px]"
                                [icon]="item.value == 'image' ? icons.faImage : icons.faList"></fa-icon>
                            <span class="whitespace-nowrap text-[12px]">{{item.label}}</span>
                        </p-button>
                    </ng-template>
                </p-selectbutton>
            </div>
        </div>
    </div>


<div class="mb-20">
    @if(viewMode === 'image')
    {
    <app-auction-listing-vertical-view [auctions]="auctionsResultSignal()"
        (myAuctionChanged)="onMyAuctionsChanged($event)"></app-auction-listing-vertical-view>
    }@else{
    <app-auction-listing-horizontal-view [auctions]="auctionsResultSignal()"
        (myAuctionChanged)="onMyAuctionsChanged($event)"> </app-auction-listing-horizontal-view>
    }


</div>
</div>


<!-- <p-paginator [rows]="per()" [first]="first()" [totalRecords]="itemsTotal()" [rowsPerPageOptions]="rowsPerPageOptions"
    (onPageChange)="onPageChange($event)" styleClass="mt-7 text-sm">
</p-paginator> -->